export default function HowItWorks() {
  const steps = [
    {
      number: '01',
      title: 'Download & Install',
      description: 'Get our VPN app from your preferred platform. Installation takes less than a minute and works on all devices.'
    },
    {
      number: '02',
      title: 'Create Account',
      description: 'Sign up with your email address. No personal information required. Start your secure journey instantly.'
    },
    {
      number: '03',
      title: 'Connect & Browse',
      description: 'Choose your server location and connect with one click. Enjoy complete privacy and unrestricted internet access.'
    }
  ];

  return (
    <section className="py-36 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="mb-24">
          <h2 className="text-5xl font-bold text-gray-900">
            Get Protected in <span className="text-cyan-500">3</span> Simple Steps
          </h2>
        </div>

        <div className="flex gap-10 overflow-x-auto pb-4">
          {steps.map((step, index) => (
            <div 
              key={index}
              className="min-w-[420px] h-[420px] rounded-[32px] bg-amber-50 p-10 flex flex-col hover:shadow-xl transition-all cursor-pointer group"
            >
              <div className="text-[120px] font-thin text-cyan-500 leading-none mb-16">
                {step.number}
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                {step.title}
              </h3>
              <p className="text-lg text-gray-600 leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}